import styled from 'styled-components/macro';
import BasicButton from 'components/elements/button';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 336px;
`;

export const Button = styled(BasicButton)`
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  width: 178px;
  margin-top: 25px;
`;

export const Title = styled('h1')`
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
`;

export const Text = styled('p')`
  font-size: 18px;
  line-height: 24px;
  text-align: left;
`;

export const IconWrapper = styled('div')`
  svg {
    width: 27px;
    height: 25px;
  }
`;
